<template>
  <div
    class="wide-table-wrapper"
  >
    <div
      class="wide-table"
      :style="{
        'min-width': nameOnly ? null : `${940 + 120*subCatalogsSorted.length}px`
      }"
    >
      <BModal
        hide-footer
        hide-header
        :visible="listingsToRemove.length > 0"
        @close="listingsToRemove = []"
      >
        <div style="font-size: 25px; text-align: center; margin-bottom: 10px">
          <i class="far fa-trash text-danger" />
        </div>
        <div class="text-center">
          <span class="font-weight-bold">
            {{ $t('shop.listingRemoveConfirm') }}
          </span>
        </div>

        <!-- <SwitchWithDescription
          title="Usuń zamówienia"
          description="Zamówienia złożone na wybraną ofertę zostaną usunięte"
          :values="removeCancelOrders"
          class="mr-3 mt-3"
          @switch="removeCancelOrders = !removeCancelOrders"
        /> -->
        <hr>
        <div class="d-flex justify-content-end">
          <div class="w-50 px-2">
            <button
              class="btn btn-sm btn-secondary btn-block"
              @click="listingsToRemove = []; checkedListings = {}"
            >
              {{ $t('general.cancel' ) }}
            </button>
          </div>
          <div class="w-50 px-2">
            <button
              class="btn btn-sm btn-danger btn-block"
              :disabled="deletePending"
              @click="remove"
            >
              {{ $t('general.remove' ) }}
            </button>
          </div>
        </div>
      </BModal>

      <div class="header d-flex">
        <div
          v-if="!hideCheckbox"
          class="checkbox"
          @click="toggleAll"
        >
          <Checkbox
            :value="checkedAll"
            class="px-0"
          />
        </div>
        <div
          v-else
          class="checkbox"
        >
          &nbsp;
        </div>

        <div
          v-if="checked.length === 0"
          style="min-width: 300px"
        >
          {{ $t('general.name') }}
        </div>
        <div
          v-else
          style="min-width: 300px"
          class="d-flex align-items-center"
        >
          <div class="text-primary pr-1">
            {{ checked.length }} {{ $t('general.selected') }}
          </div>
          <button
            v-if="dailyOrderSchema || monthlyOrderSchema"
            class="btn btn-outline-primary icon-btn mx-1"
            @click="$emit('calendar', checked)"
          >
            <i class="far fa-calendar-days" />
          </button>
          <button
            class="btn btn-outline-primary icon-btn mx-1"
            @click="listingsToRemove = checked"
          >
            <i class="far fa-trash" />
          </button>
          <!-- <Tippy
            theme="light"
            interactive
            trigger="click"
          >

            <button class="btn btn-sm btn-primary">
              Confirm remove
            </button>
          </Tippy> -->
        </div>
        <div style="min-width: 200px">
          {{ $t('shop.products') }}
        </div>
        <div
          v-for="s in subCatalogsSorted"
          :key="s.subCatalogId"
          class="assignment-column"
        >
          {{ s.name }}
        </div>
        <div
          v-if="!nameOnly"
          class="time-column"
        >
          {{ $t('shop.listing.limitCount') }}
        </div>
        <div
          v-if="!nameOnly"
          class="time-column"
        >
          {{ $t('shop.orderFrom') }}
        </div>
        <div
          v-if="!nameOnly"
          class="time-column"
        >
          {{ $t('shop.orderTo') }}
        </div>
        <div
          v-if="!nameOnly"
          class="time-column"
        >
          {{ $t('shop.cancelTo') }}
        </div>
        <div
          v-if="!nameOnly"
          style="min-width: 120px; text-align: right;"
        >
          {{ $t('shop.price') }}
        </div>
      </div>

      <ProductListingRow
        v-for="(listing, i) in listings"
        :key="create ? i : listing.id"
        :listing="listing"
        :active="activeListings && activeListings.includes(listing.id)"
        :create="create"
        :update="update"
        :hide-checkbox="hideCheckbox"
        :name-only="nameOnly"
        :checked.sync="checkedListings[listing.id]"
        :selected="listing.id === editedId"
        @select="$emit('toggle', listing.id)"
      />
    </div>
  </div>
</template>

<script>
// import SwitchWithDescription from '@/components/settings/SwitchWithDescription';
import { mapActions, mapGetters, mapState } from 'vuex';
import ProductListingRow from './ProductListingRow';

export default {
  props: {
    editedId: String,
    listings: Array,
    create: Boolean,
    update: Boolean,
    hideCheckbox: Boolean,
    nameOnly: Boolean,
    activeListings: Array,
  },
  data: () => ({
    checkedListings: {},
    listingsToRemove: [],
    deletePending: false,
  }),
  components: {
    // SwitchWithDescription,
    ProductListingRow,
  },
  computed: {
    ...mapState({
      catalog: (state) => state.shop.catalogs.catalogDetails,
    }),
    ...mapGetters('shop', ['dailyOrderSchema', 'monthlyOrderSchema']),
    checked() {
      return Object.keys(this.checkedListings).filter((x) => this.checkedListings[x]);
    },
    checkedAll() {
      if (this.listings.length === 0) return false;
      return this.listings.every((l) => this.checkedListings[l.id]);
    },
    subCatalogsSorted() {
      return this.catalog.subCatalogs
        .filter((x) => x.subCatalogId !== '#products')
        .sort((a, b) => a.ordinal - b.ordinal);
    },
  },
  methods: {
    ...mapActions('shop', ['deleteCatalogListings']),
    remove() {
      this.deletePending = true;
      this.deleteCatalogListings({
        params: {
          catalogId: this.catalog.id,
          query: {
            ids: this.listingsToRemove,
          },
        },
      })
        .then(() => {
          this.listingsToRemove = [];
          this.checkedListings = {};
        })
        .finally(() => {
          this.deletePending = false;
        });
    },
    toggleAll() {
      const v = !this.checkedAll;
      this.listings.forEach((l) => {
        this.$set(this.checkedListings, l.id, v);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  min-width: min-content;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
  min-height: 32px;
}

.checkbox {
  width: 32px;
  min-width: 32px;
  height: 20px;
  padding-top: 2px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
}

.wide-table-wrapper {
  overflow: auto;
}

.wide-table {
  margin: 0 10px;
}

.time-column {
  min-width: 100px;
}

.assignment-column {
  flex-grow: 1;
  min-width: 120px;
  max-width: 120px;
  flex-basis: 120px;
}
</style>
